import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import * as actions from './action'
import getters from './getters'
import { device } from '../utils/storage'
import Config from '../utils/global'

Vue.use(Vuex)

const state = {
  global: {
    isPc: device,
    language: 1,
    menuSelected: 'activity',
    showAgreement: false,
    agreement:'',
    currentActivityEnd: 0,
    config: Config
  },
  rule:{
   content:'',
   show:false
  },
  tempName:'',
  preCid:'',
  agreement:'',
  bread: ['内购', '全部产品'],
  specName:'尺寸',
  specNameEn:'Size',
  size:[
    {
      name:'RING',
      id:1,
      children:[{id:11,size:47},{id:12,size:48},{id:13,size:49},{id:14,size:50},{id:15,size:51},{id:16,size:52},
        {id:17,size:53},{id:18,size:54},{id:19,size:55},{id:20,size:56},{id:21,size:57},{id:22,size:58}]
    },
    // {
    //   name:'BRACELET',
    //   id:2,
    //   children:[{id:21,size:14},{id:22,size:15},{id:23,size:16},{id:24,size:17},{id:18,size:18}]
    //
    // }
  ],
  campaign: {},
  campaignList: [],
  categories: [],
  goods: [],
  searchKey: '',
  agreement_loading:false,
  currentPage: 1,
  filter: {

  },
  cartList: {
    cartNum: 0,
  },
  user: {}
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
})



// WEBPACK FOOTER //
// ./src/store/state.js